import React, { createContext, useState, useEffect, useContext, memo } from 'react';
import PubSub from 'pubsub-js'
import { useImmer } from 'use-immer';
import { Button, Card, Tooltip, OverlayTrigger, Alert } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { MessageService } from '../../services';
import { useParams } from 'react-router';
import { AuthContext } from '../../contexts/AuthContext';
import { ConditionalRender } from '../../controls/formControls';
import { MessageContext } from '../../contexts/MessageContext';
import CodingEventAttachedAlert from '../../controls/message/CodingEventAttachedAlert';
import AudienceList from '../../controls/message/AudienceList';
import MessageList from '../../controls/message/MessageList';
import JoinLeaveMessageAudience from '../../controls/message/JoinLeaveMessageAudience';

const messageInit = {
    "sentFromUserId": undefined,
    "accountId": undefined,
    "sentToUserId": undefined,
    "sentOn": new Date(),
    "subject": '',
    "message": '',
    "attachments": [],
    "responses": []
}

const Message = (props) => {
    const [message, setMessage] = useImmer(messageInit);
    const [currentUserId, setCurrentUserId] = useImmer();
    const [isInAudience, setIsInAudience] = useState();
    const { id } = useParams();
    const context = useContext(MessageContext);
    const authContext = useContext(AuthContext);


    useEffect(() => {
        if (id != undefined && id > 0) {
            getMessage(id);
        }
    }, [id])

    useEffect(() => {
        const userId = authContext.currentUser.id;
        setCurrentUserId(userId);
    }, [])

    useEffect(() => {
        setIsInAudience(message?.audience?.some(e => e.userId === currentUserId))
    }, [message])

    const getMessage = async () => {
        const messageService = new MessageService();
        const callResult = await messageService.getMessage(id);
        if (callResult.result) {
            setMessage(callResult.model);
        }
    }



    const showReplyModal = (msg) => {
        const initModel = {
            replyToName: msg.sentFromUser.fullName,
            replyToCompany: msg.sentFromUser.accountName,
            replyToMessage: msg.message,
            replyToSubject: msg.subject,
            "parentMessageId": msg.id,
            // if msg passed in is a root - then it won't have a root id - 
            // if it doesn't have a root id- then the parent must be a
            // root message.
            "rootMessageId": msg.rootMessageId || msg.id,
            "parentMessageId": msg.id,
            "sentFromUserId": currentUserId,
            "sentToUserId": msg.sentFromUserId,
            "accountId": msg.accountId,
            "sentToUserId": msg.sentFromUserId,
            "subject": '',
            "message": '',
            "attachments": [],
            "audience": []
        }
        //createMessageReply
        context.showModal({
            open: true,
            size: 'lg',
            model: initModel,
            closeModal: context.hideModal,
            onSaveCallback: updateCallback,
        }, 'createMessageReply')
    }

    const downloadFile = async (fileId, contentType, fileName) => {
        let anchor = document.createElement("a");
        document.body.appendChild(anchor);
        const messageService = new MessageService();
        var response = await messageService.getFile(id, fileId);

        if (response.result) {
            var blob = new Blob([response.model], { type: contentType });
            var link = document.createElement("a");
            link.setAttribute("href", response.model);
            link.style.display = "none";
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } else {
            window.alert('Error downloading file.');
        }
    }

    const updateCallback = () => {
        // do something with the returned message
        // insert it into the right place ----
        // I guess will have to iterate all the messages
        // and insert it in the right place???
        getMessage();
        authContext.hideModal();
    }

    return (
        <Card>
            <Card.Header className="d-flex align-items-center">
                <div className="mr-auto" ><b>Subject:</b> {message.subject}</div>
                <div className="card-btn-group">
                    <JoinLeaveMessageAudience message={message} currentUserId={currentUserId} updateCallback={updateCallback} />
                    <Button variant="primary" size="sm" onClick={() => showReplyModal(message)}>Reply</Button>
                    <LinkContainer to={'/messages'}>
                        <Button variant="secondary" size="sm">Close</Button>
                    </LinkContainer>
                </div>
            </Card.Header>
            <Card.Body className="card-body-table">
                <AudienceList message={message} updateCallback={updateCallback} />
                <CodingEventAttachedAlert codingEventId={message.codingEventId} codingEventUri="/coding/event/" />
                <MessageList message={message} currentUserId={currentUserId} />
            </Card.Body>
        </Card>
    )
}

export default Message;